import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import FootballState from "../state/football-state";
import { FragmentMessages } from "../../common/fragment-messages";

/**
 * Rebound Net fielded by kicking team fragment for Indoor Football.
 * When the ball hits the rebound net on a kickoff and is fielded by the kicking team.
 */
export default class ReboundNetFieldedKicking extends Fragment {
    constructor(fieldedBy, fieldedAt) {
        super();
        this.code = "RBNFK";
        this.fieldedBy = fieldedBy;
        this.fieldedAt = fieldedAt;

        this.requiredData = [
            {
                name: "fieldedBy",
                type: FragmentDataType.Player,
                displayName: "Fielded By",
                title: (team) => `Fielded By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "fieldedAt",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                requiredAfterNextState: [
                    FootballState.Tackle,
                    FootballState.OutOfBounds
                ]
            }
        ];
    }

    getFieldPosition() {
        return this.fieldedAt;
    }

    getPlayers() {
        return [this.fieldedBy];
    }

    getFragmentTeamId() {
        return this.fieldedBy?.teamId;
    }

    summarize(summaryContext, stringifier) {
        const message = `fielded by ${stringifier.firstInitial(
            this.fieldedBy
        )}`;
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        if (this.fieldedAt || this.fieldedAt === 0) {
            summaryContext.fieldPosition = this.fieldedAt;
        }
        summaryContext.playerInPossession = this.fieldedBy;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            fieldedBy: playerReducer(this.fieldedBy)
        };
    }
}
